import { CrudStatus } from 'forms-crud';
import {AddToCartPopupContainer} from 'block-multi-add-to-cart-client';
import {BlockComponentProps, BlockComponent} from 'client-react-block-renderer';
import {isEditing} from 'pws-client';
import {PwsHomePageProductData} from './types';
import {save} from './api';
import ProductsEditor from './ProductsEditor';
import ProductTable from './ProductsTable';
import React, {Component} from 'react';
import { GtagCartUpdateMethod } from 'google-analytics/src';

type Props = BlockComponentProps<Data>;

interface Data {
    productIds: string[];
    productOptions: PwsHomePageProductData[];
    productCount: number;
}

interface State {
    currentProductIndex: number;
    isEditing: boolean;
    productCount: number;
    productIds: string[];
    status: CrudStatus;
    dialog: 'add'|'edit'|null;
}

const DEFAULT_PRODUCT_COUNT = 3;

export default class PwsHomePageProductsBlock extends Component<Props, State>
implements BlockComponent<Data> {
    constructor(props: Props) {
        super(props);
        const data = props.data || {} as Data;
        const productCount = data.productCount == null ?
            DEFAULT_PRODUCT_COUNT :
            +data.productCount;
        const productIds = (data.productIds || []);
        this.state = {
            currentProductIndex: 0,
            dialog: null,
            isEditing: isEditing(),
            productCount,
            productIds,
            status: 'ready',
        };
    }

    protected handleAddProduct = (currentProductIndex: number) => {
        this.setState({ dialog: 'add', currentProductIndex});
    }

    protected handleClose = () => {
        if (this.state.status === 'saving') {
            return;
        }
        this.setState({ dialog: null });
    }

    protected handleChangeCount = async (value: string) => {
        const oldProductCount = this.state.productCount;
        this.setState({ status: 'saving', productCount: +value });
        try {
            await save({
                productCount: +value,
                productIds: this.state.productIds,
            });
            this.setState({ status: 'saved' });
        } catch {
            this.setState({ productCount: oldProductCount, status: 'error' });
        }
    }

    protected handleEditProduct = (currentProductIndex: number) => {
        this.setState({ dialog: 'edit', currentProductIndex });
    }

    protected handleSelectProduct = async (newProductId: string) => {
        const {state} = this;
        const oldProductIds = state.productIds;
        const productIds = oldProductIds.map((productId, i) =>
            i === state.currentProductIndex ? newProductId : productId
        );
        this.setState({ productIds, status: 'saving' });
        try {
            await save({
                productCount: state.productCount,
                productIds,
            });
            this.setState({
                dialog: null,
                status: 'saved',
            });
        } catch {
            this.setState({ productIds: oldProductIds, status: 'error' });
        }
    }

    public render() {
        const {props, state} = this;
        const productOptions = (props.data && props.data.productOptions) || [];

        if (productOptions.length === 0) {
            return <div className="pws-home-page-products">
                <a id="pws-home-page-products"/>
                <p>
                    No product options have been provided by the administrator.
                </p>
            </div>;
        }

        const currentProduct = productOptions.find(
            (o) => o && (
                o.productId === state.productIds[state.currentProductIndex]
            )
        );

        const productIdsInCount = state.productIds.slice(0, state.productCount);
        const products = productIdsInCount.map(
            (productId) => productOptions.find(
                (o) => o && (o.productId === productId)
            )
        );

        return <div className="pws-home-page-products">
            <a id="pws-home-page-products"/>
            {state.isEditing && <ProductsEditor
                isOpen={state.dialog === 'edit'}
                currentProductIndex={state.currentProductIndex}
                onCancel={this.handleClose}
                onChangeCount={this.handleChangeCount}
                onSelectProduct={this.handleSelectProduct}
                productCount={state.productCount}
                productIds={state.productIds}
                productOptions={productOptions}
                status={state.status}
            />}
            <ProductTable
                isEditing={state.isEditing && state.status !== 'saving'}
                onEditProduct={this.handleEditProduct}
                onAddProduct={this.handleAddProduct}
                products={products}
            />
            {(currentProduct && currentProduct.skuOptions.length > 0) &&
                <AddToCartPopupContainer
                    isOpen={state.dialog === 'add'}
                    onContinueShopping={this.handleClose}
                    productId={currentProduct.productId}
                    skuOptions={currentProduct.skuOptions}
                    cart_update_method={GtagCartUpdateMethod.PWS_HOME_PAGE_PRODUCTS_BLOCK}
                />
            }
        </div>;
    }
}
